import { css, breakpoints } from '../../../styles/theme';
import { rem } from 'polished';

export const StylesAP = css`
    .my-account-home {
        .imgbtn {
            border: 2px solid ${({ theme }) => theme.colors.grey7};
            position: relative;
            margin-bottom: ${rem(10)};
            &:hover {
                opacity: 0.9;
            }

            @media (min-width: ${breakpoints.sm}px) {
                margin-right: ${rem(10)};
            }
        }
    }
    .my-account-page {
        padding: ${rem(20)};

        @media (min-width: ${breakpoints.lg}px) {
            padding: ${rem(0)};
        }
    }
`;
